module.exports = __webpack_public_path__ + "static/media/dachlissen.66ae6701.jpg";